export default require('./TabShownotes').default
